import { createSelector, lruMemoize } from 'reselect';
import isEqual from 'lodash/isEqual';

export const getScrollState = createSelector(
  [
    state => state.searchAndBrowse,
    state => state.entities,
    state => state.taxonomy,
    state => state.content,
    state => state.page,
    state => state.conflicts,
  ],
  (searchAndBrowse, entities, taxonomy, content, page, conflicts) => ({
    searchAndBrowse,
    entities,
    taxonomy,
    content,
    page,
    conflicts,
  }),
  {
    memoize: lruMemoize,
    memoizeOptions: {
      equalityCheck: isEqual,
      maxSize: 10,
      resultEqualityCheck: isEqual,
    },
  },
);

export const getScrolledLineNumber = (state: WtrState) => state.scrollSessionStorage?.lineNumber;
